import useOperationLoadedState from '../hooks/use-operation-loaded-state'

export default function WhenLoaded (props) {
  const [isLoaded] = useOperationLoadedState()

  return isLoaded ? props.children : null
}
